var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocumentBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4774 10.8156H5.66406",
    stroke: "#605BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4774 8.02459H5.66406",
    stroke: "#605BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50073 5.24007H5.66406",
    stroke: "#605BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6053 1.83319C10.6053 1.83319 5.48733 1.83586 5.47933 1.83586C3.63933 1.84719 2.5 3.05786 2.5 4.90452V11.0352C2.5 12.8912 3.648 14.1065 5.504 14.1065C5.504 14.1065 10.6213 14.1045 10.63 14.1045C12.47 14.0932 13.61 12.8819 13.61 11.0352V4.90452C13.61 3.04852 12.4613 1.83319 10.6053 1.83319Z",
    stroke: "#605BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentBlue);
export default __webpack_public_path__ + "static/media/icon-document-blue.d08fd39b7197a18aaed41da63a0841c7.svg";
export { ForwardRef as ReactComponent };